import React from 'react';
import { ContentWebView } from './ContentWebView';
import { ContentContainer } from './ContentContainer';

export const GoodsWebviewContent: React.FC<{
  url: string;
  focused: boolean;
  onChangeHeight: (height: number) => void;
}> = props => {
  return (
    <ContentContainer focused={props.focused}>
      <ContentWebView
        source={{ uri: props.url }}
        onChangeHeight={props.onChangeHeight}
      />
    </ContentContainer>
  );
};
